import { createFileRoute, Outlet } from "@tanstack/react-router";
import { ExperienceModeGate } from "@/components/experience-mode-gate";

/**
 * RF parent layout — renders inside the existing app shell.
 * RfShell inside each leaf handles handheld-specific chrome
 * (header, back, single-column 360px-friendly container).
 *
 * Mode boundary: gated by the server-authoritative capability resolver
 * (worker_rf). All resolver-derived modes flow through ExperienceModeGate.
 */
export const Route = createFileRoute("/_authenticated/app/rf")({
  component: () => (
    <ExperienceModeGate mode="worker_rf">
      <Outlet />
    </ExperienceModeGate>
  ),
});